import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
// import { canNavigate } from '@/libs/acl/routeProtection'
// import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
// import apps from './routes/apps'
//import dashboard from './routes/dashboard'
// import uiElements from './routes/ui-elements/index'
// import pages from './routes/pages'
// import chartsMaps from './routes/charts-maps'
// import formsTable from './routes/forms-tables'
// import others from './routes/others'
import apiCall from '@/libs/api-call'
//import store from '@/store/index'
import friends from './routes/friends'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: '/friends'},
    //...apps,
    //...dashboard,
    //...pages,
    // ...chartsMaps,
    // ...formsTable,
    // ...uiElements,
    // ...others,
    ...friends,
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'Login' },
    },
  ],
})

router.beforeEach((to, _, next) => {
  if (to.name !== 'Login' && to.name !== 'ForgotPassword' && to.name !== 'ResetPassword' && to.name !== 'LoginWithOTP' && to.name !== 'LoginWithGoogle' && to.name !== 'LoginWithHash' && to.name !== 'ViewOrderWithHash') {
    const auth = new apiCall();
    auth.isLoggedIn().then((response) => {
      if (response === false) {
        return next({ name: 'Login' })
      } else {
        // Redirect if logged in
        if (to.meta.redirectIfLoggedIn) {
          return next()
        }
      }
    });
  } else {
    next();
  }
  
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
